// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/src/assets/moneda.png", import.meta.url);
// Module
var code = `<section class="beneficios"
    id="beneficios">



    <div class="container container--shrink beneficios__container">

        <div class="row">

            <!-- GRID -->
            <div class="beneficios__grid col-12">

                <div class="col-12 col-xl-3 text-lg-center">
                    <div class="beneficios__header">
                        <h2 class="beneficios__titulo">
                            {{ \$ctrl.beneficiosData.encabezado.titulo }}
                        </h2>

                        <p class="beneficios__subtitulo">
                            {{ \$ctrl.beneficiosData.encabezado.subtitulo }}
                        </p>
                    </div>

                </div>

                <div class="col-6  col-lg-3 beneficios__item"
                    ng-repeat="item in \$ctrl.beneficiosData.beneficios track by item.id">

                    <div class="beneficios__card">


                        <img class="beneficios__icono"
                            ng-src="{{ item.icono }}"
                            alt="{{ item.titulo }}">


                        <h3 class="beneficios__item-titulo">
                            {{ item.titulo }}
                        </h3>

                        <div class="beneficios__descripcion">
                            <h3 class="beneficios__item-titulo beneficios__item-titulo--flipped">
                                {{ item.titulo }}
                            </h3>
                            {{ item.descripcion }}
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>

    <img class="beneficios__decal d-none d-xl-block"
        src="${___HTML_LOADER_IMPORT_0___}"
        alt="billetera">
</section>`;
// Exports
export default code;